import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cc-longest-idle',
  templateUrl: './longest-idle.component.html',
  styleUrls: ['./longest-idle.component.scss']
})
export class LongestIdleComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
